import { render, staticRenderFns } from "./SettingConfig.vue?vue&type=template&id=c61b4d56&scoped=true&"
import script from "./SettingConfig.vue?vue&type=script&lang=js&"
export * from "./SettingConfig.vue?vue&type=script&lang=js&"
import style0 from "./SettingConfig.vue?vue&type=style&index=0&id=c61b4d56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c61b4d56",
  null
  
)

export default component.exports